import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const actions = [
    {
      id: 'investigate',
      label: 'Investigate Alert',
      icon: 'Search',
      variant: 'default',
      description: 'Deep dive into system alerts'
    },
    {
      id: 'restart',
      label: 'Restart Service',
      icon: 'RotateCw',
      variant: 'outline',
      description: 'Restart affected services'
    },
    {
      id: 'scale',
      label: 'Scale Resources',
      icon: 'TrendingUp',
      variant: 'secondary',
      description: 'Auto-scale infrastructure'
    },
    {
      id: 'notify',
      label: 'Notify Team',
      icon: 'Bell',
      variant: 'outline',
      description: 'Alert on-call engineers'
    },
    {
      id: 'rollback',
      label: 'Rollback Deploy',
      icon: 'Undo2',
      variant: 'destructive',
      description: 'Revert to previous version'
    },
    {
      id: 'export',
      label: 'Export Logs',
      icon: 'Download',
      variant: 'outline',
      description: 'Download system logs'
    }
  ];

  const handleAction = (actionId) => {
    console.log(`Executing action: ${actionId}`);
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h2 className="text-base md:text-lg font-semibold text-foreground">Quick Actions</h2>
        <Icon name="Zap" size={20} className="text-primary" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {actions?.map((action) => (
          <Button
            key={action?.id}
            variant={action?.variant}
            onClick={() => handleAction(action?.id)}
            iconName={action?.icon}
            iconPosition="left"
            className="justify-start h-auto py-3 px-4"
          >
            <div className="flex flex-col items-start gap-1">
              <span className="text-sm font-semibold">{action?.label}</span>
              <span className="text-xs opacity-70 caption">{action?.description}</span>
            </div>
          </Button>
        ))}
      </div>
      <div className="mt-6 p-4 rounded-lg bg-muted/30 border border-border">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={18} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-1">Emergency Protocols</h3>
            <p className="text-xs text-muted-foreground caption">
              For critical incidents, use the emergency hotline: +1 (555) 0123-4567 or trigger the incident response workflow from the alert panel.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;